// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pachirisu: PokeData = {
  "id": 417,
  "name": "pachirisu",
  "height": 4,
  "weight": 39,
  "base_experience": 142,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "bite",
    "growl",
    "thunder-shock",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "bide",
    "swift",
    "hyper-fang",
    "super-fang",
    "sweet-kiss",
    "endure",
    "charm",
    "spark",
    "crunch",
    "last-resort",
    "discharge",
    "electro-ball",
    "baby-doll-eyes",
    "nuzzle"
  ],
  "moves": [
    "bite",
    "growl",
    "thunder-shock",
    "thunder",
    "quick-attack",
    "sweet-kiss",
    "crunch",
    "thunder-punch",
    "thunder-fang",
    "thunderbolt",
    "electric-wrath",
    "volt-crash",
    "quick-tempo"
  ],
  "evolution_chain": {
    "id": 215,
    "item": null,
    "species": [
      {
        "name": "pachirisu",
        "order": 445,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 181,
    "ability_power": 86
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
